var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"repeater--vuejs"},_vm._l((parseInt(_vm.maximum, 10)),function(index){return _c('li',{key:index,class:_vm.classeLi(index)})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }